<div class="row justify-content-between">
  @if (previousAndNext$ | async; as previousAndNext) {

    @if (article && (previousAndNext[0] != '' || previousAndNext[1] != '')) {

      <div class="__back col-2"
      data-test="backButton"
      [routerLink]="[backRoute]"
      [state]="{articlesLoaded: true}"
      [style.visibility]="showBack && !breakpointService.isDesktop ? 'visible' : 'hidden'">
      <i-bs [name]="iconNames.CaretLeft"></i-bs>
      <span class="__back-text">
        Back
      </span>
    </div>
    <div class="col-auto order-2">
        <ng-container *ngTemplateOutlet="changeArticleButton; context: {$implicit: iconNames.ChevronLeft, enabled: previousAndNext[0] != '', id: previousAndNext[0], left: '', right: ''}"></ng-container>
        <ng-container *ngTemplateOutlet="changeArticleButton; context: {$implicit: iconNames.ChevronRight, enabled: previousAndNext[1] != '', id: previousAndNext[1], left: '', right: ''}"></ng-container>
      </div>

}

}
</div>
<h1 data-test="headerTitle">
  {{ title || defaultTitle }}
</h1>

<ng-template #changeArticleButton let-icon let-enabled="enabled" let-id="id" let-left="left" let-right="right">
  @if (enabled) {

      <button class="btn btn-bankruptcydata-prev-next" [libMasterRouterLink]="[contentSet , id]">
        {{left}} <i-bs class="circle-button" [name]="icon"></i-bs> {{right}}
      </button>

} @else {

    <button class="btn btn-bankruptcydata-prev-next" disabled>
      {{left}} <i-bs class="circle-button button-disabled" [name]="icon"></i-bs> {{right}}
    </button>

}
  </ng-template>
